import * as actionTypes from '../actions/actions'

export default function paymentMethods(state = {}, action) {
  switch (action.type) {
    case actionTypes.FETCH_PAYMENT_METHODS_ASYNC_START:
      return { ...state, isLoading: true }

    case actionTypes.FETCH_PAYMENT_METHODS_ASYNC_END:
      return { ...state, isLoading: true }

    case actionTypes.FETCH_PAYMENT_METHODS_SUCCESS:
      return { ...state, list: action.paymentMethods }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/paymentMethods.js